import React, { useState } from 'react';

const Topbar = ({ user, onLogout }) => {
    const [showProfileModal, setShowProfileModal] = useState(false);
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        password: ''
    });

    const handleLogout = () => {
        fetch('/core/logout/', { method: 'POST', credentials: 'include' })
            .then(() => { onLogout(); window.location.href = '/login'; })
            .catch(() => { onLogout(); });
    };

    const handleUpdateProfile = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch('https://ecopell.ledscreen.rs/core/update-profile/', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    username: typeof user === 'string' ? user : user?.username,
                    ...formData
                })
            });
            if (res.ok) {
                alert("Profil uspešno ažuriran! Ako ste menjali lozinku, prijavite se ponovo.");
                setShowProfileModal(false);
                if (formData.password) handleLogout();
            }
        } catch (err) { alert("Greška pri čuvanju."); }
    };

    const topbarStyle = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#0a132b', padding: '10px 20px', borderBottom: '1px solid #1a2a4a', width: '100%', boxSizing: 'border-box' };
    const modalStyle = { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.85)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10000 };
    const inputStyle = { width: '100%', padding: '10px', marginBottom: '15px', backgroundColor: '#050a1a', border: '1px solid #1a2a4a', color: 'white', boxSizing: 'border-box' };

    return (
        <div style={topbarStyle}>
            <div className="topbar-left">
                <img src="/assets/LogoEcopell.png" alt="EcoPell Logo" style={{ height: '40px' }} />
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div 
                    onClick={() => setShowProfileModal(true)} 
                    style={{ color: 'white', display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}
                >
                    <i className="fas fa-user-circle" style={{ fontSize: '20px', color: '#3366ff' }}></i>
                    <span style={{ fontWeight: '500', textDecoration: 'underline' }}>
                        {user && typeof user === 'string' ? user : (user?.username || 'Korisnik')}
                    </span>
                </div>
                
                <button 
                    style={{ backgroundColor: 'white', color: '#1a2a4a', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold', marginLeft: '20px' }}
                    onClick={handleLogout}
                >
                    <i className="fas fa-power-off"></i> Odjavi se
                </button>
            </div>

            {/* MODAL ZA PROFIL */}
            {showProfileModal && (
                <div style={modalStyle}>
                    <div style={{ backgroundColor: '#0a132b', padding: '30px', borderRadius: '10px', width: '400px', border: '1px solid #3366ff' }}>
                        <h3 style={{ color: 'white', marginTop: 0 }}>Uredi Profil</h3>
                        <form onSubmit={handleUpdateProfile}>
                            <input style={inputStyle} type="text" placeholder="Ime" onChange={e => setFormData({...formData, first_name: e.target.value})} />
                            <input style={inputStyle} type="text" placeholder="Prezime" onChange={e => setFormData({...formData, last_name: e.target.value})} />
                            <input style={inputStyle} type="email" placeholder="Email" onChange={e => setFormData({...formData, email: e.target.value})} />
                            <input style={inputStyle} type="password" placeholder="Nova lozinka (ostavi prazno ako ne menjaš)" onChange={e => setFormData({...formData, password: e.target.value})} />
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                                <button type="button" onClick={() => setShowProfileModal(false)} style={{ background: 'none', color: 'white', border: 'none', cursor: 'pointer' }}>Otkaži</button>
                                <button type="submit" style={{ padding: '8px 20px', backgroundColor: 'white', color: '#1a2a4a', border: 'none', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer' }}>Sačuvaj</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Topbar;